import './styles.css'
import React, { useEffect } from "react";
import { alarmsDTO,GetUserAlarmsData,DeleteUserAlarmsData, UpdateAlarmRequest, UpdateUserAlarmsData } from './tenantApiCalls';
import UserAlarmInterface from './UserAlarmsInterface';
import { useSelector } from 'react-redux';
import { RootState } from '../../state/store';

export interface userAlarmsProps {
    onClose: () => void;
}
function Index(props:userAlarmsProps) {
    const [mappedUserAlarms, setmappedUserAlarms] = React.useState<Array<alarmsDTO>>([]);
    const [selectedValue, setSelectedValue] = React.useState('-1');
    const enquiriesCache = useSelector((state: RootState) => state.EnquiryCache.data);
    
useEffect(() => {
    (async () => {
        getuserAlarmsData();
    })();
}, [enquiriesCache,selectedValue]);

const getuserAlarmsData = async () => {
    const alarm_results = await GetUserAlarmsData();
    const data = alarm_results.data;
    
    if (!data || !alarm_results.isOk) return;
        setmappedUserAlarms(data.alarms.filter(x => Date.parse(x.alarmAt) < Date.now()).sort((a, b) => a.alarmAt > b.alarmAt ? 1 : -1));
    };

const handleDismissAll = () => {
    mappedUserAlarms.forEach(element => {
        DeleteUserAlarmsData(element.id);
    });
    props.onClose();
};

const handleChange = (event:React.FormEvent<HTMLSelectElement>) => {
    
        setSelectedValue(event.currentTarget.value);
        const currentTime = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        let interval:number =(+event.currentTarget.value);
        currentTime.setMinutes(currentTime.getMinutes() + interval)
        
        mappedUserAlarms.forEach(element => {
            
            let updateAlarmRequest:UpdateAlarmRequest={
                AlarmAt : currentTime,
                Subject : element.subject,
                Notes:element.notes
            }
                UpdateUserAlarmsData(element.id,updateAlarmRequest);
        });

        setSelectedValue("-1");
        props.onClose();
};  
 
return (
    <>{(mappedUserAlarms ) &&
    <div className="userAlarmsContainer" > 
        <div className="mainHeader">{"Alarm Reminders ("+ mappedUserAlarms.length + ")"}
        </div>
            <div style={{ overflowY: "auto",height:"340px" }}>  
            
            {mappedUserAlarms.map(c => (
                <UserAlarmInterface
                    data={c}  onClose={props.onClose}
                ></UserAlarmInterface>
            ))}

            </div>
        <div className="mainfooter">
            <select id="SnoozeAll" value={selectedValue}  title='Snooze All' onChange={handleChange}>           
                <option value="-1" key="-1">Snooze All</option>
                <option value="5" key="5mins">5 mins</option>
                <option value="10" key="10 mins">10 mins</option>
                <option value="15" key="15 mins">15 mins</option>
                <option value="30" key="30 mins">30 mins</option>
                <option value="60" key="1 hour">1 hour</option>
                <option value="120" key="2 hours">2 hours</option>
                <option value="240" key="4 hours">4 hours</option>
                <option value="360" key="6 hours">6 hours</option>
                <option value="1440" key="24 hours">24 hours</option>
            </select>
            <label onClick={handleDismissAll}>Dismiss All</label>
        </div>
     </div>}
    </>
)}
export default Index